import { render, staticRenderFns } from "./UserEmailVerification.vue?vue&type=template&id=aa944ebe&"
import script from "./UserEmailVerification.vue?vue&type=script&lang=js&"
export * from "./UserEmailVerification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports